export const treatEscalationName = (escalationServiceName?: string) => {
  switch (escalationServiceName) {
    case 'servicenow':
      return 'ServiceNow';
    default:
      return escalationServiceName;
  }
};
